/* REWAY VINTAGE - portal-gedrag
   Hover op het Vintage-tab: ivoor-iris vloeit vanuit het tab over de pagina (tease).
   Klik: iris sluit zich volledig (commit) en navigeert naar de vintage-wereld.
   Op de vintage-pagina: omgekeerde iris als entree.
   Event-delegatie op document zodat theme-editor section-rerenders het gedrag
   niet breken. */
(function () {
  var d = document;
  var root = d.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  /* de hele wereld telt: /pages/vintage en de vintage-collectiepagina's */
  var onVintagePage = d.body && d.body.className.indexOf('vintage') > -1;
  var VT_URL = '/pages/vintage';

  var openTimer = null;
  var closeTimer = null;
  var navTimer = null;
  var committed = false;

  /* ---- entree op de vintage-pagina (vlag gezet bij commit) ---- */
  if (root.classList.contains('rw-vt-enter')) {
    try { sessionStorage.removeItem('rwVtEnter'); } catch (e) {}
    if (reduced) {
      root.classList.remove('rw-vt-enter');
    } else {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('rw-vt-enter-go');
          setTimeout(function () {
            root.classList.remove('rw-vt-enter', 'rw-vt-enter-go');
          }, 1150);
        });
      });
    }
  }

  /* ---- bfcache: terugknop herstelt de pagina inclusief oude klassen ---- */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      committed = false;
      root.classList.remove('rw-vt-tease', 'rw-vt-commit', 'rw-vt-enter', 'rw-vt-enter-go');
      try { sessionStorage.removeItem('rwVtEnter'); } catch (err) {}
    }
  });
  /* concurrerende navigatie wint: geplande vintage-navigatie annuleren */
  window.addEventListener('pagehide', function () {
    if (navTimer) { clearTimeout(navTimer); navTimer = null; }
  });

  function setOrigin(x, y) {
    root.style.setProperty('--vt-x', Math.round(x) + 'px');
    root.style.setProperty('--vt-y', Math.round(y) + 'px');
  }

  function openTease(fromEl) {
    if (committed || onVintagePage || reduced || !canHover) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (root.classList.contains('rw-vt-tease') || openTimer) return;
    /* korte intent-drempel: een muis die alleen langs het tab scheert opent niets */
    openTimer = setTimeout(function () {
      openTimer = null;
      if (committed) return;
      var r = fromEl.getBoundingClientRect();
      setOrigin(r.left + r.width / 2, r.top + r.height / 2);
      root.classList.add('rw-vt-tease');
    }, 110);
  }

  function keepOpen() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  }

  function scheduleClose() {
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    if (committed) return;
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      root.classList.remove('rw-vt-tease');
    }, 170);
  }

  function commit(ev) {
    if (onVintagePage) return; /* al binnen: gewoon normaal navigeren */
    /* nieuw tabblad (Ctrl/Cmd/Shift/Alt-klik): browser zijn gang laten gaan */
    if (ev && (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button === 1)) return;
    if (committed) { if (ev) ev.preventDefault(); return; }
    committed = true;
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    if (reduced) {
      /* geen animatie: vlag zetten en de link zelf laten navigeren */
      try { sessionStorage.setItem('rwVtEnter', '1'); } catch (e) {}
      return;
    }
    if (ev) ev.preventDefault();
    /* mobiele drawer staat boven de wash (z-index 95) - eerst sluiten */
    var drawer = d.getElementById('rw-drawer');
    if (drawer && !drawer.hidden) {
      drawer.hidden = true;
      d.body.style.overflow = '';
    }
    if (!root.classList.contains('rw-vt-tease') && ev && typeof ev.clientX === 'number' && ev.clientX > 0) {
      /* mobiel / geen tease actief: iris vanaf het tik-punt */
      setOrigin(ev.clientX, ev.clientY);
    }
    root.classList.remove('rw-vt-tease');
    root.classList.add('rw-vt-commit');
    navTimer = setTimeout(function () {
      try { sessionStorage.setItem('rwVtEnter', '1'); } catch (e) {}
      window.location.href = VT_URL;
    }, 600);
  }

  /* ---- event-delegatie ---- */
  d.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var tab = e.target.closest('[data-rw-vt-tab]');
    if (tab && tab.closest('.rw-catbar')) { openTease(tab); return; }
    if (e.target.closest('[data-rw-vt-wash]') && root.classList.contains('rw-vt-tease')) keepOpen();
  });

  d.addEventListener('mouseout', function (e) {
    if (!e.target || !e.target.closest) return;
    var from = e.target.closest('[data-rw-vt-tab], [data-rw-vt-wash]');
    if (!from) return;
    var to = e.relatedTarget && e.relatedTarget.closest
      ? e.relatedTarget.closest('[data-rw-vt-tab], [data-rw-vt-wash]')
      : null;
    if (!to) scheduleClose();
  });

  d.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var anchor = e.target.closest('a[href^="#vtl-"]');
    if (anchor) {
      var target = d.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
      }
      return;
    }
    if (e.target.closest('[data-rw-vt-tab]')) { commit(e); return; }
    if (e.target.closest('[data-rw-vt-wash]') && root.classList.contains('rw-vt-tease')) commit(e);
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !committed) {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      root.classList.remove('rw-vt-tease');
    }
  });
})();

/* ---- Vintage-only live search (zoekbalk op vintage-pagina's) ----
   De balk krijgt op vintage-templates data-rw-vt-predictive i.p.v. de normale
   predictive; wij zoeken client-side binnen /collections/vintage/products.json. */
(function () {
  var CACHE = null, FETCHING = null;
  function load() {
    if (CACHE) return Promise.resolve(CACHE);
    if (FETCHING) return FETCHING;
    FETCHING = fetch('/collections/vintage/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        CACHE = (j.products || []).map(function (p) {
          return {
            title: p.title, handle: p.handle,
            vendor: p.vendor || '', type: p.product_type || '',
            price: p.variants && p.variants[0] ? p.variants[0].price : '',
            img: p.images && p.images[0] ? p.images[0].src : ''
          };
        });
        return CACHE;
      })
      .catch(function () { CACHE = []; return CACHE; });
    return FETCHING;
  }
  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return '';
    return '\u20ac\u00a0' + n.toFixed(2).replace('.', ',');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function thumb(src) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=84';
  }
  var deb = null, vtSeq = 0;
  /* W7-2 gate r2 (A11y B5): zelfde toegankelijkheid als de gewone predictive — statusregio,
     aria-controls, pijltjes-navigatie en Escape-met-focus-terug. */
  function vtStatus(bar) {
    var st = bar.querySelector('[role="status"]');
    if (!st) {
      st = document.createElement('div');
      st.className = 'visually-hidden'; st.setAttribute('role', 'status'); st.setAttribute('aria-live', 'polite');
      bar.appendChild(st);
    }
    return st;
  }
  /* W7-2 gate r3 (A11y B3): expliciete state-semantiek, spiegel van de gewone predictive */
  function vtExp(inp, box) { if (inp && box) inp.setAttribute('aria-expanded', String(!box.hidden)); }
  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('[data-rw-vt-predictive]')) return;
    var bar = inp.closest('[data-rw-search]');
    var box = bar && bar.querySelector('[data-rw-predictive-results]');
    if (!box) return;
    if (!box.id) { box.id = 'rw-vtps-' + (++vtSeq); }
    if (!inp.getAttribute('aria-controls')) inp.setAttribute('aria-controls', box.id);
    if (!inp.getAttribute('role')) { inp.setAttribute('role', 'combobox'); inp.setAttribute('aria-haspopup', 'dialog'); inp.setAttribute('aria-expanded', 'false'); box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', 'Zoeksuggesties'); }
    clearTimeout(deb);
    var q = inp.value.trim().toLowerCase();
    if (q.length < 2) { box.hidden = true; box.innerHTML = ''; vtStatus(bar).textContent = ''; vtExp(inp, box); return; }
    deb = setTimeout(function () {
      load().then(function (items) {
        if (inp.value.trim().toLowerCase() !== q) return; // verouderde respons
        var words = q.split(/\s+/);
        var hits = items.filter(function (p) {
          var hay = (p.title + ' ' + p.vendor + ' ' + p.type).toLowerCase();
          return words.every(function (w) { return hay.indexOf(w) !== -1; });
        }).slice(0, 6);
        var html = '';
        if (hits.length) {
          html += '<div class="rw-ps__group" role="group" aria-label="Vintage"><div class="rw-ps__h" aria-hidden="true">Vintage</div>';
          hits.forEach(function (p) {
            html += '<a class="rw-ps__row" href="/products/' + esc(p.handle) + '">'
              + '<span class="rw-ps__img">' + (p.img ? '<img src="' + esc(thumb(p.img)) + '" alt="" loading="lazy">' : '') + '</span>'
              + '<span class="rw-ps__info"><span class="rw-ps__t">' + esc(p.title) + '</span>'
              + (p.price ? '<span class="rw-ps__m">' + money(p.price) + '</span>' : '')
              + '</span></a>';
          });
          html += '</div>';
        } else {
          html += '<div class="rw-ps--empty"><div class="rw-ps__none">Niets gevonden in Vintage.</div><a class="rw-ps__all rw-ps__all--wide" href="/search?q=' + encodeURIComponent(inp.value.trim()) + '&type=product">Zoek in de hele winkel <span aria-hidden="true">\u2192</span></a></div>'; /* W15-2c r6 (Friction B3): de enige actie ('Alle vintage-resultaten') leidde gegarandeerd naar 0 treffers */
        }
        html += '<a class="rw-ps__all" href="/search?q=' + encodeURIComponent(inp.value.trim()) + '&type=product&vintage=1">Alle vintage-resultaten <span aria-hidden="true">\u2192</span></a>';
        box.innerHTML = html;
        box.hidden = false;
        vtExp(inp, box);
        vtStatus(bar).textContent = hits.length ? (hits.length + ' suggesties, gebruik pijl omlaag') : 'Geen resultaten';
      });
    }, 140);
  });
  /* sluit de dropdown bij klik buiten de balk of Escape; pijltjes lopen door de rijen (B5) */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-rw-search]')) return;
    document.querySelectorAll('[data-rw-vt-predictive]').forEach(function (inp) {
      var bar = inp.closest('[data-rw-search]');
      var box = bar && bar.querySelector('[data-rw-predictive-results]');
      if (box) { box.hidden = true; vtExp(inp, box); }
    });
  }, true);
  document.addEventListener('keydown', function (e) {
    var ae = document.activeElement;
    var bar = ae && ae.closest ? ae.closest('[data-rw-search]') : null;
    var inp = bar ? bar.querySelector('[data-rw-vt-predictive]') : null;
    var box = bar ? bar.querySelector('[data-rw-predictive-results]') : null;
    if (inp && box && !box.hidden) {
      var rows = Array.prototype.slice.call(box.querySelectorAll('.rw-ps__row, .rw-ps__all'));
      var idx = rows.indexOf(ae);
      if (e.key === 'ArrowDown') { e.preventDefault(); (idx === -1 ? rows[0] : (rows[idx + 1] || rows[0])) && (idx === -1 ? rows[0] : (rows[idx + 1] || rows[0])).focus(); return; }
      if (e.key === 'ArrowUp' && idx !== -1) { e.preventDefault(); (idx > 0 ? rows[idx - 1] : inp).focus(); return; }
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); box.hidden = true; vtExp(inp, box); vtStatus(bar).textContent = ''; inp.focus(); return; }
    }
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-rw-vt-predictive]').forEach(function (i2) {
      var b2 = i2.closest('[data-rw-search]');
      var x2 = b2 && b2.querySelector('[data-rw-predictive-results]');
      if (x2) { x2.hidden = true; vtExp(i2, x2); }
    });
  });
  /* focus weg uit de balk = dropdown dicht (B1-spiegel) */
  document.addEventListener('focusout', function (e) {
    var bar = e.target && e.target.closest ? e.target.closest('[data-rw-search]') : null;
    if (!bar || !bar.querySelector('[data-rw-vt-predictive]')) return;
    if (e.relatedTarget && bar.contains(e.relatedTarget)) return;
    var box = bar.querySelector('[data-rw-predictive-results]');
    if (box && e.relatedTarget) { box.hidden = true; vtExp(bar.querySelector('[data-rw-vt-predictive]'), box); }
  });
})();
